export const SECOND_MS = 1000
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS

export const MINUTE_SEC = 60
export const HOUR_SEC = 60 * MINUTE_SEC
export const DAY_SEC = 24 * HOUR_SEC

/**
 * Format the timer value
 * @param {number} secondsLeft - time left in seconds
 * @returns {string} formatted timer value
 */
export function formatTimer(secondsLeft, defaultUnit = 'days') {
  const days = Math.floor(secondsLeft / DAY_SEC)
  const hours = Math.floor(secondsLeft / HOUR_SEC)
  const minutes = Math.floor((secondsLeft % HOUR_SEC) / MINUTE_SEC)
  const seconds = Math.floor(secondsLeft % MINUTE_SEC)

  let value

  if (days > 0 && defaultUnit === 'days') {
    const h = hours % 24 // get remaining hours after days

    // hours = Math.floor((secondsLeft % DAY_SEC) / HOUR_SEC)
    value = `${days}d ${h}h`

    if (h === 0) {
      value += ` ${minutes}m`
    }
  } else if (hours > 0) {
    value = `${hours}h`

    // add minutes if under 24 hours
    if (hours < 24 && hours >= 1) {
      value += ` ${minutes}m`
    } else if (hours < 1) {
      value = `${minutes}m`
    }
  } else {
    return `${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`
  }

  return `${value}`
}

export function getTimerInterval(secondsLeft) {
  const hours = secondsLeft / HOUR_SEC

  if (hours < 1) return SECOND_MS // < 1 hour: every 1 second
  if (hours < 2) return SECOND_MS * 10 // < 2 hours: every 10 seconds
  if (hours < 24) return SECOND_MS * 30 // 6-24 hours: every 30 seconds

  return MINUTE_MS // every minute for 24+ hours
}

/**
 * Check if the timer should start
 * @param {number} seconds - time left in seconds
 * @returns {boolean} should start timer
 */
export function shouldStartTimer(seconds) {
  return seconds > 0 // && seconds <= DAY_SEC
}
